const _ = "styles-module__container___v-Y8R", e = "styles-module__room_details___qpmta", o = "styles-module__expanded___fkYoZ", t = "styles-module__image_slider_container___0a-Nu", s = "styles-module__container_fullscreen___JVCVB", n = "styles-module__rate_toggle___mCDeT", l = "styles-module__room_details_container___ixxnP", i = "styles-module__room_description___AvJv9", d = "styles-module__price_info___WR3dg", r = "styles-module__from_label___SB3dq", c = "styles-module__price___7gEo1", a = "styles-module__toggle_button___ykzz4", m = "styles-module__rates_container___y-Kqz", u = "styles-module__visible___iJGmP", p = "styles-module__animated___sfeLS", y = "styles-module__description_text___OozkB", g = "styles-module__expanded_description___gKpsV", b = "styles-module__show_less_button___nxd-D", x = "styles-module__show_more_button___he9dv", f = "styles-module__ellipsis___aMZV8", h = {
  container: _,
  room_details: e,
  expanded: o,
  image_slider_container: t,
  container_fullscreen: s,
  rate_toggle: n,
  room_details_container: l,
  room_description: i,
  price_info: d,
  from_label: r,
  price: c,
  toggle_button: a,
  rates_container: m,
  visible: u,
  animated: p,
  description_text: y,
  expanded_description: g,
  show_less_button: b,
  show_more_button: x,
  ellipsis: f
};
export {
  p as animated,
  _ as container,
  s as container_fullscreen,
  h as default,
  y as description_text,
  f as ellipsis,
  o as expanded,
  g as expanded_description,
  r as from_label,
  t as image_slider_container,
  c as price,
  d as price_info,
  n as rate_toggle,
  m as rates_container,
  i as room_description,
  e as room_details,
  l as room_details_container,
  b as show_less_button,
  x as show_more_button,
  a as toggle_button,
  u as visible
};
